// Production API / site URL configuration.
// Prefer REACT_APP_* env vars; defaults match current production.

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://api.admissionsbazaar.com';

export const FRONTEND_URL =
  process.env.REACT_APP_FRONTEND_URL || 'https://www.admissionsbazaar.com';

export const SITE_URL =
  process.env.REACT_APP_SITE_URL || 'https://admissionsbazaar.com';

export const ADMIN_PORTAL_URL =
  process.env.REACT_APP_ADMIN_PORTAL_URL ||
  'https://portal.admissionsbazaar.com/admin';

export const MEDIA_BASE_URL =
  process.env.REACT_APP_MEDIA_BASE_URL || `${API_BASE_URL}/media/`;

/** Join API base with a path that may or may not start with `/`. */
export const apiUrl = (path = '') => {
  if (!path) return API_BASE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

/** Resolve media/relative asset paths against the API host. */
export const mediaUrl = (path = '') => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) {
    return path
      .replace(/https?:\/\/portal\.mycollegepedia\.com/gi, API_BASE_URL)
      .replace(/https?:\/\/api\.mycollegepedia\.com/gi, API_BASE_URL)
      .replace(/https?:\/\/(?:www\.)?mycollegepedia\.com/gi, API_BASE_URL);
  }
  if (path.startsWith('/media/')) return `${API_BASE_URL}${path}`;
  if (path.startsWith('media/')) return `${API_BASE_URL}/${path}`;
  return `${MEDIA_BASE_URL.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
};
